export default __webpack_public_path__ + "static/media/empty.52c24abe.jpeg";